import type { BookingCapacity, CapacityLine } from '@bbbk/schema';

// What a request says about itself on the desk (accept-or-decline).

const LINE_WORD: Record<CapacityLine, string> = { kennel: 'The kennel', big: 'Big', little: 'Little' };

/** *Big · 12 of 14 those nights* — the fact on a request's row on the Daily (AC3). */
export function factLabel(cap: BookingCapacity): string {
  return `${LINE_WORD[cap.lead.line]} · ${cap.lead.occupied} of ${cap.lead.hard} those nights`;
}

/**
 * *1 other request accepted for those nights* — what the fact's count leaves
 * out on purpose (AC13): an accepted request holds no place until its deposit
 * is in, so it is counted apart and said here, or she accepts two for one
 * space (PR #251 review). Empty when there are none.
 */
export function acceptedLabel(cap: BookingCapacity): string {
  const n = cap.othersAccepted;
  if (n <= 0) return '';
  return `${n} other request${n === 1 ? '' : 's'} accepted for those nights`;
}

/** A request whose check-in has passed can only be declined (AC14). */
export function lapsed(booking: { checkIn: string }, today: string): boolean {
  return booking.checkIn.slice(0, 10) < today;
}
